export const DeliveryTransferStatus = {
  Canceled: {
    label: 'Cancelada',
    color: '#eb3681',
  },
  WaitingtTranfer: {
    label: 'Aguardando Transferencia',
    color: '#FDC00F',
  },
  Transfered: {
    label: 'Transferida',
    color: '#3ac2bb',
  },
}
export default function (status) {
  for (const key in DeliveryTransferStatus) {
    const s = DeliveryTransferStatus[key]
    if (s.label === status) return DeliveryTransferStatus[key]
  }
}
